import { Component, Input, Output, EventEmitter, AfterViewInit, HostListener, ElementRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
})
export class SelectComponent implements AfterViewInit, OnChanges {
  @Input() disabled = false;
  @Input() required = false;
  @Input() noblank = false;
  @Input() tab = 1;
  @Input() focused = false;
  @Input() options: Array<any>;
  @Input() disabledOptions: Array<any>;
  @Input() label = '';
  @Input() placeholder = '';
  @Input() selected = {};
  @Input() smallSelect = false;
  @Input() searchSelect = false;
  @Input() pillBtn = false;
  @Input() fitWidth = true;
  @Input() id: string;
  @Input() invalid = false;
  @Output() selectedOption: EventEmitter<object> = new EventEmitter();

  public changed = false;
  originalOptions = [];
  firstSearch = true;
  control = new FormControl();
  @ViewChild('selectMenu') selectMenuRef: ElementRef;
  @ViewChild('selectDropdown') selectDropdownRef: ElementRef;
  @ViewChild('selectMenuDiv') selectMenuDivRef: ElementRef;
  @ViewChild('toggleButton') toggleButtonRef: ElementRef;

  constructor() {
    this.control.valueChanges.pipe(debounceTime(600), distinctUntilChanged()).subscribe((res) => {
      if (this.control.dirty) {
        if (this.firstSearch && this.options?.length > 0) {
          this.firstSearch = false;
          this.originalOptions = JSON.parse(JSON.stringify(this.options));
        }
        if (this.selectMenuDivRef && this.selectMenuDivRef.nativeElement.classList.contains('show') === false) {
          this.selectMenuDivRef.nativeElement.classList.toggle('show');
        }
        this.filterOptions();
      }
    });
  }

  ngAfterViewInit() {
    if (this.focused) {
      setTimeout(() => {
        if (this.toggleButtonRef) {
          const element = this.toggleButtonRef.nativeElement;
          element.focus();
          element.click();
        }
      }, 1);
    } else {
      setTimeout(() => {
        if (this.toggleButtonRef) {
          const element = this.toggleButtonRef.nativeElement;
          element.focus();
          element.click();
          element.click();
          element.parentElement.parentElement.parentElement.parentElement.click();
          element.blur();
        }
      }, 1);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.searchSelect && changes['selected'] && changes['selected'].firstChange) {
      if (this.searchSelect) {
        if (this.selected && this.selected.hasOwnProperty('label')) {
          this.control.setValue(this.selected['label']);
        }
      }
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    const isClickInsideComponent = this.selectDropdownRef?.nativeElement.contains(targetElement);
    
    if (!isClickInsideComponent && this.selectMenuDivRef) {
      this.selectMenuDivRef.nativeElement.classList.remove('show');
      const list = this.selectMenuDivRef.nativeElement.classList.value;
      this.selectMenuDivRef.nativeElement.classList.value = list.split('show').join('');
    }
  }

  selectFirstOption() {
    if (this.options.length > 0) {
      this.selectOption(this.options[0]);
    }
  }

  selectOption(option: any) {
    this.changed = true;
    this.selected = null;
    this.selected = option;
    if (this.searchSelect) {
      this.control.setValue(option.label);
    }
    if (this.selectMenuDivRef) {
      if (this.selectMenuDivRef.nativeElement.classList.contains('show') === true) {
        this.selectMenuDivRef.nativeElement.classList.toggle('show');
      }
    }
    this.selectedOption.emit(option);
  }

  filterOptions() {
    if (this.control.value !== '') {
      const ogOptions = JSON.parse(JSON.stringify(this.originalOptions));
      this.options = ogOptions.filter((opt) => {
        return opt.label.toLowerCase().includes(this.control.value.toLowerCase());
      });
    } else {
      this.options = JSON.parse(JSON.stringify(this.originalOptions));
    }
    if (this.options.length === 1) {
      this.selected = JSON.parse(JSON.stringify(this.options[0]));
    }
  }

  toggleMenu(event) {
    event.preventDefault();
    if (!this.selectMenuDivRef) return;
    
    if (this.selectMenuDivRef.nativeElement.classList.contains('show') === true) {
      this.selectMenuDivRef.nativeElement.classList.remove('show');
      const list = this.selectMenuDivRef.nativeElement.classList.value;
      this.selectMenuDivRef.nativeElement.classList.value = list.split('show').join('');
    } else {
      this.selectMenuDivRef.nativeElement.classList.toggle('show');
    }
  }

  clearSearch() {
    this.control.setValue('');
    this.selected = { label: '', value: '' };
    this.selectedOption.emit(this.selected);
  }

  checkDisabled(optionValue: string): boolean {
    let disabled = false;
    if (this.selectMenuDivRef && this.selectMenuDivRef.nativeElement.classList.contains('show') === true) {
      if (this.disabledOptions) {
        for (let i = 0; i < this.disabledOptions.length; i++) {
          if (this.disabledOptions[i].value === optionValue) {
            disabled = true;
          }
        }
      }
    }
    return disabled;
  }
}
